"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Workbook_1 = require("./Workbook");
class CustomView {
    constructor(_customViewImpl, _workbookImpl) {
        this._customViewImpl = _customViewImpl;
        this._workbookImpl = _workbookImpl;
    }
    get name() {
        return this._customViewImpl.name;
    }
    set name(name) {
        this._customViewImpl.name = name;
    }
    get shared() {
        return this._customViewImpl.shared;
    }
    set shared(shared) {
        this._customViewImpl.shared = shared;
    }
    get default() {
        return this._customViewImpl.isDefault;
    }
    set default(isDefault) {
        this._customViewImpl.isDefault = isDefault;
    }
    get ownerName() {
        return this._customViewImpl.ownerName;
    }
    get url() {
        return this._customViewImpl.url;
    }
    get workbook() {
        return new Workbook_1.Workbook(this._workbookImpl);
    }
    saveAsync() {
        return this._customViewImpl.saveAsync().then((customViewImpl) => {
            return new CustomView(customViewImpl, this._workbookImpl);
        });
    }
}
exports.CustomView = CustomView;
//# sourceMappingURL=CustomView.js.map